export const contentTableConfig = {
  title: '客户群数据列表',
  propList: [
    { prop: 'gid', label: '群ID', minWidth: '130' },
    { prop: 'gname', label: '群名称', minWidth: '120' },
    { prop: 'corpId', label: '主体ID', minWidth: '80' },
    {
      prop: 'corpName',
      label: '主体名称',
      minWidth: '120'
    },
    {
      prop: 'userCountPre',
      label: '上周期客户数',
      sortable: true,
      minWidth: '60'
    },
    {
      prop: 'userCountNow',
      label: '本周期客户数',
      sortable: true,
      minWidth: '60'
    },
    {
      prop: 'quitUserNum',
      label: '退群数',
      minWidth: '60',
      sortable: true,
      slotName: 'quitUserNum'
    },
    {
      prop: 'contractUserNum',
      label: '成交移群数',
      minWidth: '80',
      sortable: true,
      slotName: 'contractUserNum'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
